export default {"src":"/_next/static/media/szabojennifer3.b77c5c53.JPG","height":6240,"width":4160,"blurWidth":0,"blurHeight":0};